module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-3-img-pc@2x_225b6270f7a8bf7f885743c17d97d5bc.png";